module.exports = __webpack_public_path__ + "img/no_photo.28efd4e3.png";